"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageViewer = void 0;
var ImageViewer_1 = require("./ImageViewer");
Object.defineProperty(exports, "ImageViewer", { enumerable: true, get: function () { return __importDefault(ImageViewer_1).default; } });
